(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("imjoyLoader", [], factory);
	else if(typeof exports === 'object')
		exports["imjoyLoader"] = factory();
	else
		root["imjoyLoader"] = factory();
})(window, function() {
return 